
import {Vue, Component} from 'vue-property-decorator';
import {FeathersVuexFindAll} from '@/utils';
import {groupBy, get} from 'lodash';
import {nil} from '@/common';

@Component({
    components: {
    },
})
export default class KeyedImagesMixin extends Vue {
    public keyedImages: any = {};

    public created() {
        this.getKeyedImages();
    }

    public async getKeyedImages() {
        const ki = await FeathersVuexFindAll(this.$FeathersVuex.KeyedImage, {});
        this.keyedImages = groupBy(ki, 'key');
    }
    public extractImage(key, justUrl = false) {

        if (nil(key) || key === '') {
            return '';
        }

        const image = get(this, `keyedImages[${key}][0].imageModel.file`, '');
        const position = get(this, `keyedImages[${key}][0].imagePosition`, '');
        return justUrl ? image : `background-position:${position};background-image:url("${image}")`;
    }


}
